<template>
  <div
    class="header-tab-item"
    :class="{
      'header-tab-item_active': active
    }"
    @click="$emit('activate')"
  >
    {{ tabName }}
  </div>
</template>

<script>
  export default {
    name: 'HeaderTabItem',
    props: {
      tabName: {
        type: String,
        required: true
      },
      active: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style>
  .header-tab-item {
    font-size: 14px;

    color: var(--secondary-text-color);

    cursor: pointer;

    box-sizing: border-box;

    padding: 6px 12px;

    border: solid 1px var(--border-color);

    border-radius: 4px;
  }

  .header-tab-item:hover {
    background: var(--action-border-color);
    border-color: transparent;
  }

  .header-tab-item_active {
    background: var(--action-secondary-color);
    border-color: transparent;
  }
</style>
